export default "__VITE_ASSET__56549b8f__"